import { RiskLevel } from '@/types/dashboard.types'
import { RISK_LEVEL_CONFIG } from '@/constants/dashboard.constants'

interface RiskLevelBadgeProps {
  riskLevel: RiskLevel
  showIcon?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const RiskLevelBadge = ({
  riskLevel,
  showIcon = true,
  size = 'md',
}: RiskLevelBadgeProps) => {
  const config = RISK_LEVEL_CONFIG[riskLevel]
  const RiskIcon = config.Icon

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-2',
  }

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClasses[size]} ${config.badgeClassName}`}
    >
      {showIcon && <RiskIcon className="h-3.5 w-3.5 shrink-0" aria-hidden />}
      <span>{config.label}</span>
    </div>
  )
}
